import React, { Component } from 'react';
import classnames from 'classnames';
import '../../../css/dropdown.less';

/**
 * @param {JSX.Element} buttonContents HTML to be inserted within the dropdowns button element e.g glphicons
 * @param {JSX.Element} children An unordered list of items to appear in the dropdown
 * @description A component that renders a dropdown menu
 */
class DropDown extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
        this.dropDownRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.onDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
    }

    onDocumentClick = (e) => {
        if (!this.dropDownRef.current.contains(e.target)) {
            this.setState({ isOpen: false });
        }
    }

    onClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    render() {
        const classes = classnames({
            'dropdown-box': true,
            'is-open': this.state.isOpen,
        });

        return (
            <div className={classes}>
                <button ref={this.dropDownRef} className="dropdown-btn" onClick={this.onClick}>
                    {this.props.buttonContents}
                </button>
                <div className="dropdown-list-wrapper">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default DropDown;
